<template>
<section class="venuesDatesPrices">
    <div class="container">

      <div class="columns has-text-centered">

        <div class="column is-1">
        </div>

        <div class="column" v-for="price in item.prices" :key="price._id">
          <img src="/images/icons/iconTicket.png" srcset="/images/icons/iconTicket@2x.png 2x" />
          <ul>
            <li class="nav-item"
              <div class="title3">{{ price.title }}</div>
              <p class="text-small">{{ price.price }}</p>
            </li>
          </ul>
        </div> 

        <div class="column" v-for="date in item.dates.displayedText" :key="date._id">
          <img src="/images/icons/iconClock.png" srcset="/images/icons/iconClock@2x.png 2x" />
          <ul>
            <li class="nav-item"
              <div class="title3">{{ date.title }}</div>
              <p class="text-small">{{ date.description }}</p>
            </li>
          </ul>
        </div> 

        <div class="column" v-for="venue in item.venues" :key="venue._id">
          <img src="/images/icons/iconLocation.png" srcset="/images/icons/iconLocation@2x.png 2x" />
          <ul>
            <li class="block"
              <div class="title3">Venue</div>
              <p class="text-small">{{ venue.name }}, {{ venue.address }}</p>
                <a class="text-small" :href="venue.maplink" alt="Directions to the venue" target="_blank">See map</a>
            </li>
          </ul>
        </div> 

        <div class="column is-1">
        </div>

      </div> 

    </div>
</section>
</template>

<script>
var moment = require('moment');
// import Api from '@/config/Api'; // MCH added
//import VenuesDatesPricesStrip from './VenuesDatesPricesStrip';

export default {
    props: ['item'],
    methods: {
        prettifydate(date) {
            return moment(date).format("dddd, Do MMMM YYYY");
        },
        truncatedBlurb(blurb) {
            var output = this.$options.filters.truncate(blurb, 350)
            // | truncate(160, '...')
            return output;
        }
    },

}
</script>

<style scoped>

.venuesDatesPrices {
  background: transparent !important;
}
.venuesDatesPrices .container {
  margin-top: 3.5rem;
  margin-bottom: 2rem;
}
.venuesDatesPrices .title3 {
  margin-top: 0.4rem;
}
.venuesDatesPrices .text-small {
  margin: 0.4rem 0 0.4rem 0;
}

</style>



// WEBPACK FOOTER //
// src/components/cards/VenuesDatesPricesStrip.vue